import { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

function AppLayout({
  children,
  title = "Dashboard",
  subtitle = "",
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const openMobileMenu = () => {
    setMobileMenuOpen(true);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="app-layout">
      <div
        className={`mobile-sidebar-wrapper ${
          mobileMenuOpen ? "open" : ""
        }`}
      >
        <Sidebar onNavigate={closeMobileMenu} />
      </div>

      {mobileMenuOpen && (
        <button
          type="button"
          className="mobile-sidebar-overlay"
          onClick={closeMobileMenu}
          aria-label="Close mobile menu"
        />
      )}

      <div className="main-wrapper">
        <Topbar
          title={title}
          subtitle={subtitle}
          onMenuClick={openMobileMenu}
        />

        <main className="content-area">
          {children}
        </main>
      </div>
    </div>
  );
}

export default AppLayout;